import without from 'lodash/without';
import lifecycle from 'recompose/lifecycle';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { t } from '../../../modules/infra/i18n';
import Layout from './components/Layout';
import AppointmentsReport from './appointmentsReport/appointmentsReport';
import Filters from './filters/FiltersContainer';
import PaymentFilter from './filters/paymentFilterContainer';
import BarberFilter from './barbersReport/barberFilterContainer';
import AppointmentBookedByFilter from './appointmentsReport/AppointmentBookedByFilter';
import AppointmentStatusFilter from './appointmentsReport/AppointmentStatusFilter';
import AppointmentPlatformFilter from './appointmentsReport/AppointmentPlatformFilter';
import {
  getAppointmentsReport,
  getReportFiltersDirty,
  getSelectedFilterSlugs,
  getSelectedFilterNames,
  getPaymentFilters,
  getAppointmentStatusFilters,
  getAppointmentPlatformFilters,
  getAppointmentBookedByFilters,
  getSelectedBarberFilterIds,
} from './selectors';
import { canLoadReport } from './helpers';
import ExportableReport from './ExportableReport';
import { getActiveType, getIsRentalBarber } from '../../auth/selectors';
import ShopFilter from './filters/ShopFilter';
import { RoleAllowBrand } from '../../auth/roleAware';

const AppointmentReport = ({
  getCsv,
  handleFilterSubmit,
  appointments,
  filtersDirty,
  canLoadReport,
  barberIds,
  payments,
  status,
  platform,
  bookedBy,
  showBarberName,
  shopFilter,
  activeType,
  showDepositsSecured,
}) => (
  <Layout title={t('reports:appointments_report.title')}>
    <Filters
      csv={getCsv}
      submit={handleFilterSubmit}
      disableBarberFilter
      headerTextClass="c-label u-ml--"
      endingDateMax=""
      showCsvExport={canLoadReport}
    />
    <ExportableReport
      canLoadReport={canLoadReport}
      name="appointments-report"
      label={t('reports:appointments_report.label')}
      additionalFilters={{ shopFilter, barberIds, payments, status, platform, bookedBy }}
    >
      <div className="o-flexbox o-flexbox--justify-start u-mb">
        <RoleAllowBrand>
          <div className="u-visible-for-extralarge-and-up u--ml--">
            <ShopFilter />
          </div>
        </RoleAllowBrand>
        <div className={classNames({ 'c-form-input-group__item': true, 'u-ml--': activeType === 'brand' })}>
          <div className="c-label">{t('reports:filter_by_barber')}</div>
          <BarberFilter showUnassigned={false} className="" />
        </div>
        <PaymentFilter removeFilters={[]} />
        <AppointmentBookedByFilter />
        <AppointmentStatusFilter />
        <div className="u-visible-for-extralarge-and-up">
          <AppointmentPlatformFilter />
        </div>
        <div className="u-hidden-for-extralarge-and-up u-mt--">
          <AppointmentPlatformFilter currentView="list" />
        </div>
      </div>
      <AppointmentsReport
        appointments={appointments}
        filtersDirty={filtersDirty}
        showBarberName={showBarberName}
        showShopName={activeType === 'brand'}
        showDepositsSecured={showDepositsSecured}
      />
    </ExportableReport>
  </Layout>
);

const mapStateToProps = state => ({
  appointments: getAppointmentsReport(state),
  showLoading: state.main.loading_in_progress,
  timezone: state.auth.timezone,
  filtersDirty: getReportFiltersDirty(state),
  canLoadReport: canLoadReport(state),
  barberIds: without(getSelectedBarberFilterIds(state), 'unassigned'),
  payments: getSelectedFilterSlugs(getPaymentFilters(state)),
  status: getSelectedFilterSlugs(getAppointmentStatusFilters(state)),
  platform: getSelectedFilterNames(getAppointmentPlatformFilters(state)),
  bookedBy: getSelectedFilterSlugs(getAppointmentBookedByFilters(state)),
  showBarberName: !getIsRentalBarber(state),
  activeType: getActiveType(state),
});

export default compose(
  connect(mapStateToProps),
  withHandlers({
    handleFilterSubmit: props => () => {
      props.getReport();
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.getReport();
    },
  })
)(AppointmentReport);
